<template>
  <section class="user-evaluations" fluid>
    <v-layout class="section-box" row wrap align-center>
      <v-flex xs12 md8>
        <span class="my-2 mx-4">
          <div v-if="currentSubscription && currentSubscription.status !== 'cancelled' && currentSubscription.status !== 'finished'">
            <p>
              Plano: <strong>{{ currentPlan.description }}</strong>
              <br>
              <span v-if="currentSubscription.charges_detail.last_charged_date">
                Último pagamento:
                <strong>{{ currentSubscription.charges_detail.last_charged_date | moment('LLL') }}</strong>
              </span>
              <br>
              <span v-if="currentSubscription.charges_detail.next_payment_date">
                Próximo pagamento:
                <strong>{{ currentSubscription.charges_detail.next_payment_date | moment('LLL') }}</strong>
              </span>
              <br>
              <span v-if="currentSubscription.charges_detail.charged_amount">
                Total pago em todo o período:
                <strong>{{ currentSubscription.charges_detail.charged_amount | formatCurrency }}</strong>
              </span>
              <br>
              <span v-if="currentSubscription.charges_detail.last_charged_amount">
                Último valor pago:
                <strong>{{ currentSubscription.charges_detail.last_charged_amount | formatCurrency }}</strong>
              </span>
            </p>
            <v-btn round depressed small outline color="deep-orange darken-2"
              @click="updateSubscriptionStatus('cancelled', 'cancelar')" :loading="loadingRequest">
              <v-icon small left>fal fa-times-circle</v-icon>
              Cancelar plano
            </v-btn>
            <v-btn round depressed small outline @click="updateSubscriptionStatus('paused', 'pausar')"
              v-if="currentSubscription.status !== 'paused'" :loading="loadingRequest">
              <v-tooltip bottom>
                <span slot="activator">
                  <v-icon small left>fal fa-pause-circle</v-icon>
                  Pausar plano
                </span>
                <span>As cobranças serão pausadas</span>
              </v-tooltip>
            </v-btn>
            <v-btn round depressed small outline @click="updateSubscriptionStatus('authorized', 'retomar')"
              v-if="currentSubscription.status === 'paused'" :loading="loadingRequest">
              <v-icon small left>fal fa-pause-circle</v-icon>
              Retomar plano
            </v-btn>
          </div>
          <template v-else>
            <strong>Sem plano ativo</strong>
            <v-btn round depressed small color="success" dark
              v-modal-trigger="'showFinancialPlan'" :data-item="JSON.stringify(user)">
              Cadastrar plano
            </v-btn>
          </template>
        </span>
      </v-flex>
      <v-flex xs12 md4 class="text-xs-right">
        <v-btn round depressed small color="deep-orange darken-2" dark
          v-modal-trigger="'showNewNotification'" :data-item="JSON.stringify(newNotificationData)">
          Notificar aluno
          <v-icon small right>fal fa-bell</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <admin-user-show-financial-plan v-if="userMP && userMP.id" :userMP="userMP" />
    <!-- <admin-user-show-financial-transactions v-if="userMP && userMP.id" :userMP="userMP" /> -->
  </section>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'

import UserPlanLabel from '@/modules/UserPlanLabel'
import AdminUserShowFinancialPlan from '@/components/admin/userShow/AdminUserShowFinancialPlan'
import AdminUserShowFinancialTransactions from '@/components/admin/userShow/AdminUserShowFinancialTransactions'

export default {
  data: () => ({
    loadingRequest: false,
    userMP: {},
    currentPlan: null,
    currentSubscription: null
  }),

  methods: {
    loadUserOnMP () {
      const params = {
        'email': this.user.email
      }
      const path = `${API.mpCustomers}/search`

      axios.post(path, params).then(payload => {
        const response = payload.data.customers.response
        if (response.results && response.results.length) {
          const customer = response.results[0]

          if (customer.email === this.user.email) {
            this.userMP = customer
            this.loadPlan()
          } else {
            this.createUserOnMp(this.user)
          }
        } else {
          this.createUserOnMp(this.user)
        }
      }).catch(errors => {
        this.loadingRequest = false
        // EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar aluno no Mercado Pago', color: 'error' })
      })
    },

    createUserOnMp (user) {
      const params = {
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        identification: {
          type: 'CPF',
          number: user.document_number
        }
      }
      const path = `${API.mpCustomers}`

      axios.post(path, params).then(response => {
        if (response && response.data && response.data.customer.response) {
          this.userMP = response.data.customer.response
        }
      }).catch(errors => {
        this.loadingRequest = false
        // EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
        EventBus.$emit('showSnackbar', { message: 'Erro ao criar aluno no Mercado Pago', color: 'error' })
      })
    },

    loadPlan () {
      if (!this.userMP || !this.userMP.metadata || !this.userMP.metadata.plan_id) return false
      const userPlanId = this.userMP.metadata.plan_id
      const path = `${API.mpPlans}/${userPlanId}`

      axios.get(path).then(response => {
        if (response && response.data && response.data.plan.response) {
          this.currentPlan = response.data.plan.response
        }
        this.loadSubscription()
      }).catch(errors => {
        this.loadingRequest = false
        // EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
        EventBus.$emit('showSnackbar', { message: 'Erro carregar o plano no Mercado Pago', color: 'error' })
      })
    },

    loadSubscription () {
      if (!this.userMP || !this.userMP.metadata || !this.userMP.metadata.subscription_id) return false
      const userSubscriptionId = this.userMP.metadata.subscription_id
      const path = `${API.mpSubscriptions}/${userSubscriptionId}`

      axios.get(path).then(response => {
        if (response && response.data && response.data.preapproval.response) {
          this.currentSubscription = response.data.preapproval.response
        }
      }).catch(errors => {
        this.loadingRequest = false
        // EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
        EventBus.$emit('showSnackbar', { message: 'Erro carregar a assinatura no Mercado Pago', color: 'error' })
      })
    },

    updateSubscriptionStatus (status, title, confirmUnRequired) {
      this.loadingRequest = true
      const path = `${API.mpSubscriptions}/${this.currentSubscription.id}`
      const params = { status: status }

      if (!confirmUnRequired) {
        confirm(`Tem certeza que deseja ${title} o plano ?`) && this.updateSubscriptionStatus(status, title, true)
        this.loadingRequest = false
        return
      }

      if (status === 'cancelled') {
        axios.put(`${API.users}/${this.user._id}`, { plan: 'cancelado' })
      }

      axios.put(path, params).then(response => {
        this.loadUserOnMP()
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        // EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
        EventBus.$emit('showSnackbar', { message: 'Erro atualizar a assinatura no Mercado Pago', color: 'error' })
      })
    }
  },

  computed: {
    newNotificationData () {
      return {
        user: this.user._id,
        all_users: false,
        title: 'Cadastre seu cartão',
        message: 'Para ativar o seu plano, é necessário que você cadastre um cartão de crédito.',
        url: `${API.siteURL}/financial`
      }
    }
  },

  beforeDestroy () {
    EventBus.$off('loadUserOnMP')
    EventBus.$off('loadSubscription')
    EventBus.$off('loadPlan')
  },

  mounted () {
    EventBus.$on('loadUserOnMP', this.loadUserOnMP)
    EventBus.$on('loadSubscription', this.loadSubscription)
    EventBus.$on('loadPlan', this.loadPlan)
    this.loadUserOnMP()
  },

  components: {
    UserPlanLabel,
    AdminUserShowFinancialPlan,
    AdminUserShowFinancialTransactions
  },

  props: ['user']
}
</script>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowFinancial.vue